export const SEND_OTP_API_HTTP_STATUS_CODES = [
  400, 403, 404, 422, 500, 503, 504,
];

export const SEND_OTP_ERROR_MESSAGE = "Error in getting otp, please try again.";

export const USER_ACTIONS_API_HTTP_STATUS_CODES = [
  400, 401, 403, 404, 422, 500, 503, 504,
];

export const ALLOW_USER_API_ERROR_MESSAGE =
  "Error in allowing candidate, please try again.";

export const LEAVE_ALL_API_ERROR_MESSAGE =
  "Error in ending interview for all, please try again.";

export const LEAVE_API_ERROR_MESSAGE =
  "Error in ending interview, please try again.";

export const GET_USER_STATUS_API_HTTP_STATUS_CODES = [
  401, 403, 404, 422, 500, 503, 504,
];

export const GET_USER_STATUS_ERROR_MESSAGE =
  "Error in getting user status, please try again.";

export const START_INTERVIEW_API_HTTP_STATUS_CODES = [400, 403, 404, 422];

export const START_INTERVIEW_ERROR_MESSAGE =
  "Error in starting interview, please try again";

export const JOIN_INTERVIEW_API_HTTP_STATUS_CODES = [
  400, 401, 403, 404, 422, 500, 503, 504,
];

export const JOIN_INTERVIEW_ERROR_MESSAGE =
  "Error in joining interview, please try again.";
